export default "__VITE_ASSET__D3XZlw39__"